<template>
    <div>
        <el-dialog
            title="用车开始"
            :visible.sync="dialogShow"
            width="50%"
            :fullscreen="dialogFull"
            :destroy-on-close="true"
            top="30px"
            before-close="handleClose"
            :close-on-click-modal="false"
            append-to-body
            :modal-append-to-body="false">
            <template slot="title">
                <div class="avue-crud__dialog__header">
                        <span class="el-dialog__title">
                            用车开始
                        </span>
                        <i class="el-icon-full-screen" style="margin-right:20px;position:relative;top:-1px"  @click="dialogFull=!dialogFull"></i>
                        
                </div>
      </template>
      <div style="max-height:calc(100vh - 320px);overflow-y:scroll;overflow-x:hidden;">
            <avue-form 
                :option="option"
                v-model="form"
                ref="form"
                v-if="dialogShow"
                @submit="formSubmit"
                @error="formError">
                <template slot="carId">
                        <el-select v-model="form.carId" placeholder="请选择" style="width:100%" @change="carNoChange">
                            <el-option
                                v-for="item in carNoList"
                                :key="item.carId"
                                :label="item.carNo"
                                :value="item.carId">
                            </el-option>
                        </el-select>
                </template>
                <template slot="startMileage">
                        <el-input type="number" @input="startMileageInput" placeholder="里程数 (千米)" :value="form.startMileage">
                             <el-button slot="append" >千米</el-button>
                        </el-input>
                </template>
                 <template slot="remark">
                        <div>
                            <el-input
                                type="textarea"
                                :rows="3"
                                maxlength="500"
                                show-word-limit
                                placeholder="请输入内容"
                                v-model="form.remark">
                            </el-input>
                            <remarkModel :remark.sync="form.remark" ref="scrapFormRemarkModel"></remarkModel>
                        </div>
                    </template>
                <template slot="attachList">
                    <div>
                        <vupload :fileList.sync="form.attachList"></vupload>
                    </div>
                </template>   
                <!-- <template slot="menuForm">
                    <el-button @click="handleClose" ><span class="el-icon-close"></span> 取消</el-button>
                </template> -->
            </avue-form>
      </div>
      <template slot="footer"> 
                <el-button @click="formSubmit1" size="small" type="primary"><span class="el-icon-check"></span> 保存</el-button>
                <el-button @click="handleClose" size="small" style="margin-right:15px"><span class="el-icon-close" ></span> 取消</el-button>
            </template>
        </el-dialog>
    </div>
</template>
<script>
    import {getCarDetails, getCarNoList} from "@/api/crmedical/car/car-record/index";
import {
    startOption,
} from "./option.js";
import { getGroupDetails,
        getCooperateList,
        setCooperate,
        confirm,
        getRemarkList,
        start,
        lazyAreaTree
 } from "@/api/gateservice/order/order-list/order-list";
import remarkModel from "../components/remark-model";
import vupload from "@/views/components/v-upload";
export default {
    components:{
        remarkModel,vupload
    },
    data(){
        return{
            carNoList:[],
            dialogFull:false,
            form:{
                orderId:'',
                attachList:[],
                areaId:'',
            },
            treeFormAreaData:[],//懒加载区域树 --报修表单中
            treeProps: {//报修表单 --需求区域树的配置
                //标题
                label: 'name',
                //值
                value: 'id',
                //子节点
                children: 'zones',
                //是否叶子节点
                isLeaf: 'hasChildren',
                //本节点类型key值
                objectType: 'id',
                //本节点类型名
                objectTypeName: 'name',
            },
            data:{},
            cheackedPeople:[],
            userList:[],
            dialogShow:false,
            option:startOption
        }
    },
    created(){
    },
    methods:{
            getCarNoListFunc(id){
                return getCarNoList({ projectId: id });
            },
            carNoChange(val){
                this.getCarDetailsFunc(val).then((res)=>{
                    this.form.type = res.data.type;
                    this.form.carVehicleName = res.data.carVehicleName;
                    this.form.vehicleType = res.data.vehicleType;
                    this.form.series = res.data.series;
                    this.form.model = res.data.model;
                    this.form.brand = res.data.brand;
                });
                
            },
            getCarDetailsFunc(id){
                return getCarDetails({ carId: id });
            },
        // 弹窗关闭前
        handleClose(done){
                let self = this;
                this.$confirm('确认关闭?', '提示', {
                        confirmButtonText: '确定',
                        cancelButtonText: '取消',
                        type: 'warning',
                })
                .then(()=> {
                        
                        self.dialogShow = false;
                        
                })
                .catch(()=> {
                        
                });
        },
        openDialog(data){
            this.dialogShow = true;
            console.log("openDialog")
            this.data = data;
            this.form = {
                orderId:data.orderId,
                attachList:[],

                
            }
            getRemarkList({orderId:data.orderId,actionType:data.actionType}).then(res=>{
                this.$refs.scrapFormRemarkModel.setRemarkList(res.data);
            })
            this.getCarNoListFunc(this.data.projectId).then((res)=>{
                this.carNoList = res.data;
            })
        },
        closeDialog(){
            this.dialogShow = false;
        },
        formError(done){
            done()
        },
        startMileageInput(e){
            this.form.startMileage = e.slice(0,10);
        },
        formSubmit1(){
      this.$refs.form.submit();
    },
        formSubmit(form,done){
            
            // 业务数据
            let temObj = {startMileage:form.startMileage,startSite:form.startSite,startTime:form.estimateEndTime,carId:form.carId}
            form.moduleJson= JSON.stringify(temObj)
            start(form).then(res=>{
                if(res.msg=='操作成功'){
                    this.$message({
                        message: res.msg,
                        type: 'success'
                    });
                     this.dialogVisible = false;
                     this.dialogShow = false;
                }else{
                    this.$message.error(res.msg);
                }
                this.$emit('handleClose',function(){console.log('关闭历程表')})
                
                this.dialogShow = false;
                done()
            }).catch(err=>{
                
                
                done()
            })
        },
        //  -- 服务地点切换
        editAreaNodeTreeClick_(node){
            if(parseInt(node.nodeType)==1){
            // this.$message.error();
                return;
            }
            setTimeout(() => {
                let nodeId = node.id;
                let nodeTitle = node.name;
                // this.form.areaName = nodeTitle;
                // this.form.areaId = nodeId;
            
                    this.form = Object.assign({}, this.form,{
                    'areaName':nodeTitle,
                    "areaId":nodeId});
                    this.$refs.addConnectSelect.blur();
               
            }, 0);
        },
        // 报修表单  --服务地点数据
        editAreaLazyLoadTree(node, resolve) {
            let id;
            if (node.level === 0) {
                id = 0;
            } else {
                id = node.data.id;
            }
            lazyAreaTree({ parentId: id, projectId: this.data.projectId}).then(({ data }) => {
                if (data instanceof Array ) {
                    data.forEach(item => {
                    item.hasChildren = !item.hasChildren;
                    })
                }
                resolve(data);
            });
        },
    }
}
</script>
